/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { PAGE_NAMES } from '@zcode/mixpanel'
import {
  checkDetailView,
  checkGalleryView,
  checkHomepageView,
  checkPermanentAddressView,
  checkRentResearchView,
  selectIsRailPage,
} from '../../../inspectors/index'
import { logger } from '../../../logger'

// TODO: There is similar logic at nzr/src/utils/getPageType.js that we use on the server and at
// nzr/src/server/utils/determinePageType.ts that we use for the server. Each serves a slightly
// different purpose currently but we should eventually consolidate. This version uses a different set of constants
// for page names that don't match up 1-to-1 with how we log them in the other two files for grafana for server metrics and client web-vitals
export const getPageNameFromRouteProps = ({
  routeProps,
  isMobile,
}: {
  isMobile?: boolean
  routeProps: { location: { pathname: string; search: string } }
}) => {
  if (routeProps?.location) {
    let page
    if (selectIsRailPage(routeProps)) {
      page = isMobile ? PAGE_NAMES.SEARCH_LIST : PAGE_NAMES.SEARCH
    } else if (checkHomepageView(routeProps)) {
      page = PAGE_NAMES.HOMEPAGE
    } else if (checkGalleryView(routeProps)) {
      page = PAGE_NAMES.VERTICAL_GALLERY
    } else if (checkDetailView(routeProps)) {
      page = PAGE_NAMES.DETAIL
    } else if (checkPermanentAddressView(routeProps)) {
      page = PAGE_NAMES.PERM_ADDRESS
    } else if (checkRentResearchView(routeProps)) {
      if (routeProps.location.pathname.split('/').length > 2) {
        page = PAGE_NAMES.RENT_RESEARCH_DETAIL
      } else {
        page = PAGE_NAMES.RENT_RESEARCH_HOME
      }
    } else {
      const { location } = routeProps
      page = `${location.pathname}${location.search}`
    }
    return page
  }
  logger.error('getPageNameFromRouteProps called without routeProps:', routeProps)
}
